import PricingLayout from "@/components/PricingLayout";
import { ROUTE_SEO } from "@/config/seoData";
import { ELITE_PACKAGES } from "@/config/pricingData";

const ELITE_MATRIX = [
  ["Advanced technical SEO", [true, true, true]],
  ["Content strategy", ["Roadmap", "Strategy + ops", "Full-funnel ops"]],
  ["Competitor analysis", [true, true, true]],
  ["International SEO", [false, true, "Global"]],
  ["Ecommerce SEO", [false, true, true]],
  ["Authority development", ["Growth", "Digital PR", "Leadership"]],
  ["AI visibility (GEO / AEO)", [false, true, true]],
  ["Advanced reporting", ["Dashboards", "Dashboards + workshops", "Executive + governance"]],
];

const EliteSeoPackages = () => (
  <PricingLayout
    testid="elite-seo-packages"
    seo={ROUTE_SEO.eliteSeoPackages}
    eyebrow="Elite SEO Packages"
    title="Enterprise search programs for market leaders"
    intro="Three enterprise packages engineered for competitive and global markets — advanced technical SEO, content strategy, competitor intelligence, international and ecommerce SEO, authority development and AI visibility (GEO/AEO). Scoped to your organisation — request a quote."
    packages={ELITE_PACKAGES}
    matrix={ELITE_MATRIX}
    crossLink={{
      prompt: "Need a focused, transparent package for steady organic growth instead?",
      href: "/seo-pricing/",
      label: "View Standard SEO Pricing",
    }}
  />
);

export default EliteSeoPackages;
